export default [
  { name: 'email_master_account_imap', type: 'json' },
  { name: 'email_master_account_smtp', type: 'json' },
  { name: 'email_master_account_signature', type: 'json' },
  { name: 'vat_percent', type: 'number' },
  { name: 'currency', type: 'currency' },
  { name: 'property_page_slug', type: 'text' },
  { name: 'area_page_slug', type: 'text' },
];



// WEBPACK FOOTER //
// ./src/frontend/modules/settings/global/global-settings.js